import { SHIPMENT_CLASSIFICATION } from '../constants'

const initialState = { signature: null, result: null }

export default function shipmentClassificationReducer(state = initialState, action) {
	switch (action.type) {
		case SHIPMENT_CLASSIFICATION.SET:
			return { signature: action.signature, result: action.result }
		case SHIPMENT_CLASSIFICATION.CLEAR:
			return initialState
		default:
			return state
	}
}